import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import UpdateTrendingPlaceImageForm from '~/components/Content/TrendingPlaces/UpdateTrendingPlaceImageForm';

type props = {
  open: boolean;
  onClose: () => void;
};

const UpdateTrendingPlaceImageModal = ({ open, onClose }: props) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Assign Trending Place Image</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mt: 1 }}>
          Choose an image, then select the markets and brands where it should appear. This does not add or remove a
          destination, or change its position.
        </DialogContentText>
        <UpdateTrendingPlaceImageForm onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export default UpdateTrendingPlaceImageModal;
